// extracted by mini-css-extract-plugin
export default {"file-size-errors":"sCIF6IuNL4i3cwZniJvh"};